import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';

const WrapperInfoUser = styled.div`
  ${mediaqueries.greaterThan('tablet')`
    float: left;
    margin-right: ${rem('18px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
      float: none;
      margin-right: 0;
      `};
`;

const LineUserContact = styled.p`
  display: flex;
  font-size: ${rem('14px')};
  margin-bottom: ${rem('15px')};

  &:last-child {
    margin-bottom: 0;
  }

  ${mediaqueries.between('mobile', 'desktop')`
    margin: ${rem('10px')} 0 ${rem('20px')} 0;
    &:last-child {
      margin-bottom: 0;
    }
  `};
`;

const InfoLineUser = styled.span`
  margin-left: 0.5rem;
`;

const WrapperSocial = styled.div`
  display: flex;
  margin-top: 1rem;
  flex-direction: row;
  ${mediaqueries.greaterThan('tablet')`
    flex-direction: column-reverse;
    border-left: ${rem('2px')} solid #000000;
    height: ${rem('80px')};
    justify-content: space-between;
    padding-left: ${rem('20px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    flex-direction: row;
    border-left: none;
    height: auto;
    padding-left: 0px;
  `};
`;

const StyledLink = styled.a`
  display: block;
`;

const ItemsSocial = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 75%;
  justify-content: space-between;
  &:after {
    background-color: ${props => props.theme.colors.dark};
    content: '';
    display: block;
    height: ${rem('15px')};
    width: ${rem('2px')};
    position: relative;
    top: ${rem('2px')};
  }
  &:empty:after {
    display: none;
  }

  &:last-child {
    padding-right: 0;

    &:after {
      content: none;
    }
  }
  ${mediaqueries.greaterThan('tablet')`
    flex-basis: auto;
    justify-content: flex-start;
    &:after {
      content: none;
    }
    a {
      margin-right: ${rem('15px')};
    }
    ${StyledLink} {
      margin-right: ${rem('5px')};
    }    
  `};
  ${mediaqueries.greaterThan('tablet')`
    flex-basis: 75%;
    justify-content: flex-start;    
  `};
  ${mediaqueries.greaterThan('desktop')`    
    &:after {
      background-color: ${props => props.theme.colors.dark};
      content: '';
      display: block;
      height: ${rem('15px')};
      width: ${rem('2px')};
      left: ${rem('12px')}; 
    }
  `};
`;

const ItemContact = ItemsSocial.extend`
  flex-basis: 25%;
  justify-content: flex-start;
  ${mediaqueries.greaterThan('desktop')`
    flex-basis: 25%;
  `};
`;

const IconContact = styled(Icon)`
  flex-shrink: 0;
  margin-left: ${rem('20px')};

  ${mediaqueries.greaterThan('tablet')`
    &:first-child {
      margin-left: 0;
    }
  `};

  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('30px')};
    width: ${rem('30px')};
    &:first-child {
      margin-left: ${rem('20px')};
    }
  `};
`;

const LinksSocialNetwork = styled.a`
  display: block;

  ${mediaqueries.greaterThan('tablet')`
    &:last-child {
      margin-right: 0;
    }
  `};

  ${mediaqueries.greaterThan('desktop')`
     margin-left: 0;
  `};
`;

const StyleEditIcon = styled(Icon)`
  position: absolute;
  top: ${rem('10px')};
  right: ${rem('10px')};
`;

const StyledDiv = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: start;
  background: #f3f3f3;
  margin: ${rem('16px')};
  > div {
    width: 100%;
    min-height: ${rem('230px')};
  }
  ${mediaqueries.greaterThan('tablet')`
    margin-left: 0;
    margin-right: 0;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('348px')};
    margin-top: ${rem('37px')};
  `};
`;

export {
  WrapperInfoUser,
  LineUserContact,
  InfoLineUser,
  WrapperSocial,
  ItemsSocial,
  ItemContact,
  IconContact,
  LinksSocialNetwork,
  StyleEditIcon,
  StyledDiv,
  StyledLink
};
